import { Maybe } from '@csp/csp-common-model';
import { DrawerWideSize } from '../model/DrawerWideSize';

const calcSizeLgUpWidth = (size: DrawerWideSize): string => {
  if (size === 'medium') {
    return '60rem';
  } else {
    return '75rem';
  }
};

const calcWidth = (fullWidth: boolean, mdUp: boolean, lgUp: boolean, size: DrawerWideSize): Maybe<string> => {
  if (fullWidth || mdUp) {
    return '100%';
  } else if (lgUp) {
    return calcSizeLgUpWidth(size);
  } else {
    return undefined;
  }
};

export const TemporaryDrawerWideMapper = {
  calcSizeLgUpWidth,
  calcWidth,
};
